import { getApiPathResolver } from '@/utils/api-path-resolver';

/**
 * 登录状态变化处理器
 * 在用户登录/登出时清除API路径缓存
 */
export class LoginStateHandler {
    private static instance: LoginStateHandler;

    private constructor() {}

    static getInstance(): LoginStateHandler {
        if (!LoginStateHandler.instance) {
            LoginStateHandler.instance = new LoginStateHandler();
        }
        return LoginStateHandler.instance;
    }

    /**
     * 处理用户登录成功事件
     */
    onLoginSuccess(): void {
        console.log('[LoginStateHandler] User logged in, clearing API path cache');
        getApiPathResolver().clearCache();
    }

    /**
     * 处理用户登出事件
     */
    onLogout(): void {
        console.log('[LoginStateHandler] User logged out, clearing API path cache');
        getApiPathResolver().clearCache();
    }

    /**
     * 处理登录状态变化事件
     * @param isLoggedIn 新的登录状态
     */
    onLoginStateChange(isLoggedIn: boolean): void {
        console.log(`[LoginStateHandler] Login state changed to: ${isLoggedIn}`);
        getApiPathResolver().clearCache();
    }
}

/**
 * 获取登录状态处理器实例
 */
export const getLoginStateHandler = () => LoginStateHandler.getInstance();